import type { FaireProductEntity } from "../../entity_types/product";

export const p_bx5jjgef: FaireProductEntity = {
  token: "p_bx5jjgef",
  type: "product",
  name: "Thank You Universe",
  brandToken: "b_3a5ba274",
  brandName: "Lucky Horse Press",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/097f5d4b998397e7af1feb07e2e5be878d14b1229a1ca39bb59314a35e8d1504/1534862718.jpg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    '• Letterpress printed by Lucky Horse Press\n\n• 100 lb. recycled cover\n\n• 4.25" × 5.5" folded cards\n\n• Blank inside\n\n• Matching envelopes',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:03.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
